import { ACTIONS_TYPES } from "../utils/constants";

export const initialState = {
  errors: null,
  configs: null,
  loader: false,
};

export default function appConfigReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIONS_TYPES.APP_CONFIGS_REQUEST:
      return { ...state, loader: true, errors: null };

    case ACTIONS_TYPES.APP_CONFIGS_SUCCESS:
      return { ...state, configs: action.payload, loader: false };

    case ACTIONS_TYPES.APP_CONFIGS_FAILED:
      return { ...state, loader: false, errors: action.payload };

    case ACTIONS_TYPES.LOGOUT_REQUEST:
      return { ...initialState  };

    default:
      return state;
  }
}